import { configureStore } from "@reduxjs/toolkit";
import collectionBarReducer from "./ducks/collection-bar";
import cookieConsentReducer from "./ducks/cookie-consent";
import cookieSettingsReducer from "./ducks/cookie-settings";
import customerCaptureOverlayReducer from "./ducks/customer-capture-overlay";
import eventCountTrackerReducer from "./ducks/event-count-tracker";
import feedFiltersReducer from "./ducks/feed-filters";
import feedSidebarReducer from "./ducks/feed-sidebar";
import signupOverlayReducer from "./ducks/signup-overlay";
import appHeaderSearchReducer from "./ducks/app-header-search";
import appHeaderCartReducer from "./ducks/app-header-cart";
import shippingAndReturnsOverlayReducer from "./ducks/shipping-and-returns-overlay";
import feedShowMoreReducer from "./ducks/feed-show-more";
import feedShowPreviousReducer from "./ducks/feed-show-previous";
import feedSeoContentReducer from "./ducks/feed-seo-content";
import mainNavigationReducer from "./ducks/main-navigation";
import topBannerReducer from "./ducks/top-banner";
import followDesignerBannerReducer from "./ducks/follow-designer-banner";
import sendToAppModalReducer from "./ducks/send-to-app-modal";
import feedCountReducer from "./ducks/feed-count";

const store = configureStore({
    reducer: {
        collectionBarReducer,
        cookieConsentReducer,
        cookieSettingsReducer,
        customerCaptureOverlayReducer,
        eventCountTrackerReducer,
        feedFiltersReducer,
        feedSidebarReducer,
        signupOverlayReducer,
        appHeaderSearchReducer,
        appHeaderCartReducer,
        shippingAndReturnsOverlayReducer,
        feedShowMoreReducer,
        feedShowPreviousReducer,
        feedSeoContentReducer,
        mainNavigationReducer,
        followDesignerBannerReducer,
        topBannerReducer,
        sendToAppModalReducer,
        feedCountReducer,
    },
});

export type ReduxStoreState = ReturnType<typeof store["getState"]>;

export default store;
